module.exports = __webpack_public_path__ + "assets/map.6f015d7e.svg";